import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import NpMobileLogo from "../../assets/images/logo/NpLogoMobile.svg";
import styles from "./IPEX2026Pg.module.css";
import { Flex } from "@mantine/core";
import NowSvg from "../../assets/images/ipex/now.svg";
import MetalCloudLogo from "../../assets/images/ipex/metal-cloud.svg";
import HeroSection from "./HeroSection/HeroSection";
import HeroTitle from "./HeroTitle/HeroTitle";
// import FrameImage from "../../assets/images/ipex/frame.svg";
import ProductImage from "../../assets/images/ipex/products.png";
import FoundryImage from "../../assets/images/ipex/foundry.png";
import FinanceImage from "../../assets/images/ipex/finance.png";
import { IconArrowNarrowRight, IconArrowNarrowLeft } from "@tabler/icons-react";
import NewButton from "./NewButton/NewButton";
// import MetalCloudCard from "./MetalCloudCard/MetalCloudCard";
import ProductCard from "./ProductCard/ProductCard";
import ExpertCallForm from "./ExpertCallForm/ExpertCallForm";
import FormMessage from "./FormMessage/FormMessage";
import AnimatedView from "./AnimatedView/AnimatedView";
import VideoPlayerModal from "./VideoPlayerModal/VideoPlayerModal";
import { config } from "../../utils/config";
import ipexBg from "../../assets/images/ipex/background.svg";

const { videoFlagship, videoScrapRecycling, videoMetalCloud, videoFinance } = config.ipex;

export default function IPEX2026Pg() {
  const [view, setView] = useState(0); // 0: home, 1: form, 2: submit message, 3: error message
  const [videoModal, setVideoModal] = useState({ open: false, url: "" });
  const [bgLoaded, setBgLoaded] = useState(false);

  const openVideo = (url) => setVideoModal({ open: true, url });
  const closeVideo = () => setVideoModal((prev) => ({ ...prev, open: false }));

  useEffect(() => {
    const img = new Image();
    img.src = ipexBg;
    img.onload = () => setBgLoaded(true);
    img.onerror = () => setBgLoaded(true);
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [view]);

  if (!bgLoaded) {
    return <div className={styles.loader} />;
  }

  return (
    <div className={styles.kiosPg} style={{ backgroundImage: `url(${ipexBg})` }}>
      <Flex justify="center" align="center" direction="column" style={{ gap: "80px" }}>
        <HeroSection logo={NpMobileLogo} />
        <AnimatePresence mode="wait">
          {view === 0 ? (
            <motion.div
              key="heroTitle"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.25 }}
            >
              <HeroTitle nowSvg={NowSvg} />
            </motion.div>
          ) : (
            <motion.div
              key="backButton"
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.25 }}
              style={{ width: "100%" }}
            >
              <Flex justify="flex-start" w="100%" style={{ marginTop: "80px" }}>
                <NewButton leftSection={<IconArrowNarrowLeft strokeWidth={3} size={30} />} onClick={() => setView(0)} style={{ width: "400px" }}>
                  Back to Home Page
                </NewButton>
              </Flex>
            </motion.div>
          )}
        </AnimatePresence>
      </Flex>

      <AnimatePresence mode="wait">
        {view === 0 && (
          <AnimatedView key="home">
            <Flex direction={"column"} style={{ gap: "100px" }}>
              <Flex direction={"column"} style={{ gap: "28px" }} wrap={"wrap"}>
                {/* <MetalCloudCard
                  logo={MetalCloudLogo}
                  frameImage={FrameImage}
                  videoUrl={videoMetalCloud}
                  onWatchClick={() => openVideo(videoMetalCloud)}
                /> */}
                <div className={styles.cardsRow}>
                  <ProductCard
                    title="MetalCloud AI"
                    description="The only way to TRULY end Guesswork in your foundry in 90 Days"
                    image={MetalCloudLogo}
                    imageAlt="metal cloud"
                    videoUrl={videoFlagship}
                    onWatchClick={() => openVideo(videoMetalCloud)}
                  />
                  <ProductCard
                    title="Flagship Range"
                    description="Reliable Materials, Perfect Casts Guaranteed every time"
                    image={ProductImage}
                    imageAlt="flagship"
                    videoUrl={videoFlagship}
                    onWatchClick={() => openVideo(videoFlagship)}
                  />
                  <ProductCard
                    title="Scrap Recycling"
                    description="Standardized Metal Scrap for your Melting Needs"
                    image={FoundryImage}
                    imageAlt="scrap recycling"
                    videoUrl={videoScrapRecycling}
                    onWatchClick={() => openVideo(videoScrapRecycling)}
                  />
                  <ProductCard
                    title="NP Finance"
                    description="Unlock working capital, drive growth"
                    image={FinanceImage}
                    imageAlt="np finance"
                    videoUrl={videoScrapRecycling}
                    onWatchClick={() => openVideo(videoFinance)}
                  />
                </div>
              </Flex>

              <NewButton
                className={styles.scheduleButton}
                rightSection={<IconArrowNarrowRight strokeWidth={3} size={40} />}
                onClick={() => setView(1)}
              >
                Schedule 1-on-1 Expert Consultancy
              </NewButton>
            </Flex>
          </AnimatedView>
        )}

        {view === 1 && (
          <AnimatedView key="form">
            <ExpertCallForm onSuccess={() => setView(2)} onError={() => setView(3)} />
          </AnimatedView>
        )}
        {view === 2 && (
          <AnimatedView key="success">
            <FormMessage type="success" />
          </AnimatedView>
        )}
        {view === 3 && (
          <AnimatedView key="error">
            <FormMessage type="error" />
          </AnimatedView>
        )}
      </AnimatePresence>

      <VideoPlayerModal isOpen={videoModal.open} videoUrl={videoModal.url} onClose={closeVideo} />
    </div>
  );
}
